module.exports = __webpack_public_path__ + "img/left_line.c604ca02.png";